import gql from 'graphql-tag';
import { appointmentTypesFragments } from 'api/graphql/v2/fragments/AppointmentTypes';

export const GET_APPT_TYPES_CONFIG = gql`
  query($eventType: String!, $isActive: Boolean) {
    appointmentTypesConfig(eventType: $eventType, isActive: $isActive) {
      ...AppointmentTypesConfig
    }
  }
  ${appointmentTypesFragments.appointmentTypesConfig}
`;

export const GET_ALL_APPT_TYPES = gql`
  query($eventTypes: [String!]!) {
    allAppointmentTypesConfig(eventTypes: $eventTypes) {
      ...AllAppointmentTypesConfig
    }
  }
  ${appointmentTypesFragments.allAppointmentTypesConfig}
`;

export const GET_ABA_APPOINTMENT_SUBTYPES = gql`
  query {
    appointmentSubTypesConfig(eventType: "ABA") {
      ...ABAAppointmentSubTypeConfig
    }
  }
  ${appointmentTypesFragments.ABAAppointmentSubTypeConfig}
`;

export const GET_DT_APPOINTMENT_SUBTYPES = gql`
  query($isActive: Boolean) {
    appointmentSubTypesConfig(eventType: "DT", isActive: $isActive) {
      ...DTAppointmentSubTypeConfig
    }
  }
  ${appointmentTypesFragments.DTAppointmentSubTypeConfig}
`;

export const GET_MED_APPOINTMENT_SUBTYPES = gql`
  query($isActive: Boolean) {
    appointmentSubTypesConfig(eventType: "MED", isActive: $isActive) {
      ...MEDAppointmentSubTypeConfig
    }
  }
  ${appointmentTypesFragments.MEDAppointmentSubTypeConfig}
`;

export const GET_COUNSELING_APPOINTMENT_SUBTYPES = gql`
  query($isActive: Boolean) {
    appointmentSubTypesConfig(eventType: "Counseling", isActive: $isActive) {
      ...CounselingAppointmentSubTypeConfig
    }
  }
  ${appointmentTypesFragments.CounselingAppointmentSubTypeConfig}
`;

export const GET_APPT_TYPES_WITH_SUB_TYPES = gql`
  query($includeAdminTypes: Boolean!, $sidebarState: Boolean) {
    allAppointmentTypes(
      includeAdminTypes: $includeAdminTypes
      sidebarState: $sidebarState
    ) {
      ...AppointmentTypesTableData
      appointmentSubTypes {
        id
        title
        requiresSfrReason
        DTSetting {
          id
          duration
        }
        CounselingSetting {
          id
          duration
        }
        MEDSetting {
          id
          duration
        }
      }
    }
  }
  ${appointmentTypesFragments.appointmentTypesTableData}
`;

export const GET_APPT_TYPES = gql`
  query {
    allAppointmentTypes(includeAdminTypes: false) {
      ...AppointmentTypeData
    }
  }
  ${appointmentTypesFragments.appointmentTypesData}
`;

export const GET_DELETE_WHEN_CANCEL_APPOINTMENTS_IDS = gql`
  query {
    deleteWhenCancelAppointmentsIds
  }
`;
